import { createBrowserRouter, Navigate, RouteObject, Outlet } from 'react-router-dom';
import { AdminLayout } from '../layouts/AdminLayout';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { BrandProvider } from '../contexts/BrandContext';
import { LoginPage } from '../pages/Login/LoginPage';
import { MeetingsListPage } from '../pages/Meetings/MeetingsListPage';
import { RaceDrillDownPage } from '../pages/Meetings/RaceDrillDown/RaceDrillDownPage';
import { PredictedExoticsPage } from '../pages/PredictedExotics/PredictedExoticsPage';
import { MultisPage } from '../pages/Multis/MultisPage';
import { AnalysisModelsPage } from '../pages/AnalysisModels/AnalysisModelsPage';
import { UsersListPage } from '../pages/Users/UsersListPage';
import { UserDetailPage } from '../pages/Users/UserDetailPage';
import { SubscriptionPackagesPage } from '../pages/SubscriptionPackages/SubscriptionPackagesPage';
import { SubscriptionsListPage } from '../pages/Subscriptions/SubscriptionsListPage';
import { DiscountsPage } from '../pages/Discounts/DiscountsPage';
import { SystemSettingsPage } from '../pages/SystemSettings/SystemSettingsPage';
import { StripePriceMappingsPage } from '../pages/StripePriceMappings/StripePriceMappingsPage';
import { PromotionsPage } from '../pages/Promotions/PromotionsPage';
import { TracksPage } from '../pages/Tracks/TracksPage';
import { MarketingPage } from '../pages/Marketing/MarketingPage';
import { DashboardPage } from '../pages/Dashboard/DashboardPage';
import { AiPromptsPage } from '../pages/AiPrompts/AiPromptsPage';
import { RevenuePage } from '../pages/Revenue/RevenuePage';
import { RacingAnalyticsPage } from '../pages/RacingAnalytics/RacingAnalyticsPage';
import { AdminUsersPage } from '../pages/AdminUsers/AdminUsersPage';
import { ErrorLogPage } from '../pages/ErrorLog/ErrorLogPage';
import { MessagesPage } from '../pages/CustomerMessages/MessagesPage';
import { AffiliatesPage } from '../pages/Affiliates/AffiliatesPage';
import { AffiliateDetailPage } from '../pages/Affiliates/AffiliateDetailPage';
import { BrandSettingsPage } from '../pages/BrandSettings/BrandSettingsPage';

export const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <BrandProvider>
          <AdminLayout>
            <Outlet />
          </AdminLayout>
        </BrandProvider>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'predicted-exotics',
        element: <PredictedExoticsPage />,
      },
      {
        path: 'multis',
        element: <MultisPage />,
      },
      // The screen was Predicted First 4s until 2026-09-23; keep old links working.
      {
        path: 'predicted-first-4s',
        element: <Navigate to="/predicted-exotics" replace />,
      },
      {
        path: 'meetings',
        element: <MeetingsListPage />,
      },
      {
        path: 'meetings/:meetingId/races',
        element: <RaceDrillDownPage />,
      },
      {
        path: 'analysis-models',
        element: <AnalysisModelsPage />,
      },
      {
        path: 'ai-prompts',
        element: <AiPromptsPage />,
      },
      {
        path: 'revenue',
        element: <RevenuePage />,
      },
      {
        path: 'racing-analytics',
        element: <RacingAnalyticsPage />,
      },
      {
        path: 'admin-users',
        element: <AdminUsersPage />,
      },
      {
        path: 'errors',
        element: <ErrorLogPage />,
      },
      {
        path: 'messages',
        element: <MessagesPage />,
      },
      {
        path: 'messages/:conversationId',
        element: <MessagesPage />,
      },
      {
        path: 'affiliates',
        element: <AffiliatesPage />,
      },
      {
        path: 'affiliates/:affiliateId',
        element: <AffiliateDetailPage />,
      },
      {
        path: 'users',
        element: <UsersListPage />,
      },
      {
        path: 'users/:userId',
        element: <UserDetailPage />,
      },
      {
        path: 'subscriptions',
        element: <SubscriptionsListPage />,
      },
      {
        path: 'subscription-packages',
        element: <SubscriptionPackagesPage />,
      },
      {
        path: 'discounts',
        element: <DiscountsPage />,
      },
      {
        path: 'brand-settings',
        element: <BrandSettingsPage />,
      },
      {
        path: 'system-settings',
        element: <SystemSettingsPage />,
      },
      {
        path: 'stripe-price-mappings',
        element: <StripePriceMappingsPage />,
      },
      {
        path: 'promotions',
        element: <PromotionsPage />,
      },
      {
        path: 'tracks',
        element: <TracksPage />,
      },
      {
        path: 'marketing',
        element: <MarketingPage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
